import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import TabNav from '../components/TabNav/TabNav'
import VacancyManagerForm from '../components/Company/VacancyManagerForm/VacancyManagerForm'
import { setProfileTitle } from '../redux/actions/ui.action'
import VacancyManagerListHeader from '../components/Company/VacancyManagerList/VacancyManagerListHeader'
import VesselManagerForm from '../components/Company/VesselManagerForm/VesselManagerForm'
import VesselManagerList from '../components/Company/VesselManagerList/VesselManagerList'
import VacancyManagerTemplates from '../components/Company/VacancyManagerTemplates/VacancyManagerTemplates.jsx'
import { profilePaths } from '../constants/constants'
import VacancyManagerTemplatesListHeader from '../components/Company/VacancyManagerTemplates/VacancyManagerTemplatesList/VacancyManagerTemplatesListHeader.jsx'
import ModerationStatus from '../components/ModerationStatus/ModerationStatus'

const classes = {
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 34,
  },
}

const links = [
  {
    url: profilePaths.create_vacancy,
    title: 'Vacancy creation',
  },
  {
    url: profilePaths.create_vessel,
    title: 'Vessel  registration',
  },
  {
    url: profilePaths.vacancy_templates,
    title: 'Vacancies templates',
  },
]

const VacancyManagerPage = () => {
  const dispatch = useDispatch()
  const containerRef = useRef(null)
  const companyData = useSelector(({ company }) => company)
  const isModerationNotificationVisible = !companyData.is_active
  useEffect(() => {
    dispatch(setProfileTitle('Vacancy Manager'))
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <TabNav links={links} />
      {isModerationNotificationVisible && (
        <div className="container" style={{ marginTop: '20px', marginBottom: '20px' }}>
          <ModerationStatus data={companyData} />
        </div>
      )}

      <div ref={containerRef} className="container">
        <div style={{ ...classes.content, paddingTop: isModerationNotificationVisible ? 0 : classes.content.paddingTop }}>
          <Switch>
            <Route exact path={profilePaths.create_vessel}>
              <VesselManagerForm container={containerRef} />
              <VesselManagerList />
            </Route>

            <Route exact path={profilePaths.create_vacancy}>
              <VacancyManagerForm container={containerRef} />
              <VacancyManagerListHeader />
            </Route>

            <Route exact path={profilePaths.vacancy_templates}>
              <VacancyManagerTemplates container={containerRef} />
              <VacancyManagerTemplatesListHeader />
            </Route>

            <Redirect to={profilePaths.create_vacancy} />
          </Switch>
        </div>
      </div>
    </>
  )
}

export default VacancyManagerPage
